import Vue from 'vue'
import VueI18n from 'vue-i18n'
import zh from './locales/zh'
import en from './locales/en'

Vue.use(VueI18n)

const i18n = new VueI18n({
  locale: localStorage.getItem('grabgo_privacy_lang') || 'zh',
  fallbackLocale: 'zh',
  messages: {
    zh,
    en,
  },
})

export default i18n
